<template>
    <section v-if="!this.carNotFound" class="confirm-my-car" id="confirmMyCar">
        <div class="confirm-my-car__container container">
            <StepBar />

            <StepLink :step="1" />

            <h3 class="title">Vehicle Details</h3>

            <LoadingSpinner v-if="!selectedVehicle" />

            <img v-if="selectedVehicle" class="confirm-my-car__car-image" :src="vehicleImage" alt="Car Image" />
            <div class="card confirm-my-car__card">
                <div class="card__inner confirm-my-car__card-inner-desktop">
                    <img v-if="selectedVehicle" class="img-responsive confirm-my-car__car-image-desktop" :class="{ 'confirm-my-car__not-found-image': this.carNotFound }" :src="vehicleImage" alt="Car Image" />
                    <div class="confirm-my-car__car-details-desktop">
                        <h3 v-if="selectedVehicle" class="card__heading">{{ selectedVehicleTitle }}</h3>
                        <p v-if="selectedVehicle" class="card__text">{{ selectedVehicle.derivative }}</p>

                        <NonFranchiseVehicleError v-if="this.isNonFranchiseVehicle" />
                        <button type="button" class="btn btn--primary btn--full-width card__button" @click.prevent="next_step" v-else>
                            <span class="find-my-car__used-btn-txt">Yes, Continue</span>
                        </button>
                        <a class="confirm-my-car__card-link" v-if="!this.isNonFranchiseVehicle" @click.prevent="showCarForm">This is not my car</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <CarNotFoundForm v-else />
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex/dist/vuex.esm.browser";
import { LoadingSpinner, StepBar, StepLink, CarNotFoundForm, NonFranchiseVehicleError } from "../";
import EventObject from "../../../modules/tracking/EventObject";

export default {
    components: {
        LoadingSpinner,
        StepBar,
        StepLink,
        CarNotFoundForm,
        NonFranchiseVehicleError,
    },

    computed: {
        ...mapState("OSB", ["selectedVehicle", "otherSelected", "carNotFound", "isNonFranchiseVehicle"]),
        ...mapState("Auth", ['authenticated', 'vehicleRegistered']),
        ...mapGetters("OSB", ["vehicleImage"]),
        selectedVehicleTitle() {
            if (!this.selectedVehicle) {
                return '';
            }
            if (this.selectedVehicle.make == 'DS' && String(this.selectedVehicle.model).substring(0, 2) == 'DS') {
                return this.selectedVehicle.model;
            }
            return this.selectedVehicle.make + ' ' + this.selectedVehicle.model;
        }
    },

    methods: {
        ...mapMutations("OSB", ["incrementStep", "setPricingData", "setCarNotFound"]),

        showCarForm() {
            new EventObject("OSB", "Click", "Not my car clicked").dispatch();
            this.setCarNotFound(true);
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        checkIfVehicleIsRegistered() {
            let registration = null
            if(this.selectedVehicle){
                registration = this.selectedVehicle.registration ?? null
            }
            return new Promise((resolve, reject) => {
                this.$store.dispatch('Auth/registeredVehicle', {
                    vehicleReg: registration
                })
                    .then(() => {
                        this.guest = !this.vehicleRegistered
                        resolve();
                    })
                    .catch(error => {
                        console.error('registered vehicle check error:', error);
                        reject(error);
                    });
            });
        },

        next_step() {
            new EventObject("OSB", "Click", "Confirm your car, continue clicked").dispatch();
            this.checkIfVehicleIsRegistered();

            if (this.authenticated){
                this.$store.dispatch('CustomerData/updateCustomerData', { root: true });
            }

            this.$emit('collect-service-plan');
            this.incrementStep();
            this.scrollToTop();
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/Steps/ConfirmYourCar.vue